import { render, staticRenderFns } from "./Honeypot.vue?vue&type=template&id=37f0b448"
import script from "./Honeypot.vue?vue&type=script&lang=ts"
export * from "./Honeypot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports